import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../common/InputField";
import Button from "../../common/Button";

// Scss imports
import css from "./ChangePasswordForm.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

interface ChangePasswordFormProps {
  handleChange: Function;
  password: string;
  repeatedPassword: string;
  onClickButtonHandler: Function;
  errorPasswordText: string;
  errorRepeatedPasswordText: string;
  disabledButton: boolean;
  onInputPassword: Function;
  resetPasswordMessage?: any;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  handleChange,
  password,
  repeatedPassword,
  disabledButton,
  errorPasswordText,
  errorRepeatedPasswordText,
  onInputPassword,
  onClickButtonHandler,
  resetPasswordMessage
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Нова шифра"
          name="password"
          id="password"
          type="password"
          placeholder="password@gmail.com"
          value={password}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Password12345")}
          errorText={errorPasswordText}
          onInputHandler={onInputPassword}
        />
      </div>

      <InputField
        label="Потврда"
        name="repeatedPassword"
        id="repeated"
        type="password"
        placeholder="password@gmail.com"
        value={repeatedPassword}
        handleChange={handleChange}
        handleOnFocus={(e: any) => (e.target.placeholder = "")}
        handleOnBlur={(e: any) => (e.target.placeholder = "Password12345")}
        errorText={errorRepeatedPasswordText}
      />

      <p>{resetPasswordMessage}</p>

      <div className={css.buttonHolder}>
        <Button
          disabledButton={disabledButton}
          text="Пошаљи"
          onButtonClickHandler={() =>
            /*dispatch(
							signup(
								{
									email: email,
									password: password,
									passwordConfirm: repeatedPassword
								},
								history
							)
						)*/
            onClickButtonHandler()
          }
        />
        <Link to="/signin">
          <p>Знате шифру, улогујте се</p>
        </Link>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
